import * as React from "react";
import { TagLabel, Flex } from "@draftkings/arena-web";
export const FreeBet = React.memo(function FreeBet(props) {
    const { label, testId } = props;
    return (React.createElement(Flex, { gap: "8px", alignItems: "center", marginBottom: "12px" },
        React.createElement(TagLabel, { as: "span", testId: testId, variant: "freeBet" }, label)));
});
//# sourceMappingURL=FreeBet.js.map